import SHARED_STYLES from 'json/shared_styles.json';
export var plot_config = {
  SHARED_STYLES: SHARED_STYLES,
  Y_AXIS_LABEL: 'GWh',
  TOOLTIP_KEYS: ['currentMonthly', 'prevYearMonthly', 'historicalMonthly'],
  TOOLTIP_Y_MARGIN: 15,
  Y_AXIS_LABEL_X: 5,
  Y_AXIS_LABEL_Y: -10,
  TOOLTIP_X_MARGIN: 20,
  TOOLTIP_SIDE_PADDING: 9,
  TOOLTIP_TOP_BOTTOM_PADDING: 7,
  BAR_COLOR_MAP: {
    currentMonthly: SHARED_STYLES.graphColors[3],
    prevYearMonthly: SHARED_STYLES.graphColors[0],
    historicalMonthly: SHARED_STYLES.graphColors[2]
  },
  BAR_TOOLTIP_TEXT_MAP: {
    currentMonthly: 'Current Year:',
    prevYearMonthly: 'Previous Year:',
    historicalMonthly: 'Historical Mean:'
  }
};
export var margin = {
  top: 60,
  right: 20,
  bottom: 70,
  left: 30
};
export var marginBrush = {
  top: 530,
  bottom: 10,
  left: 30
};